import React from 'react';
import PropTypes from 'prop-types';
// styles
import styled, { css } from 'styled-components';
// components
import { AddCircleIcon } from 'refactored/ui/icons';

const AddButton = ({ handleAdd, className, label }) => (
  <button className={className} onClick={handleAdd} aria-label={label}>
    <AddCircleIcon />
    {label}
  </button>
);

AddButton.propTypes = {
  handleAdd: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default styled(AddButton)`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: var(--primary500);
  ${(props) =>
    !!props.label &&
    css`
      ${AddCircleIcon} {
        margin-right: 9px;
      }
    `}
`;
